import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import objectSupport from 'dayjs/plugin/objectSupport';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';

// Extends dayjs to supply timezone, e.g. dayjs().tz('America/Los_Angeles')
dayjs.extend(utc);
dayjs.extend(timezone);

// Extends dayjs to supply more format options, e.g. dayjs().format('Q Do k kk X x')
dayjs.extend(advancedFormat);

// Extends dayjs to supply object argument, e.g. dayjs().set({ year: 2010, month: 1, day: 12 })
dayjs.extend(objectSupport);

// Extends dayjs to supply relative time strings, e.g. dayjs().from(dayjs('1990')) // 2 years ago
dayjs.extend(relativeTime);

// Extends dayjs to suuply localized format options, e.g. dayjs().format('L LT')
dayjs.extend(localizedFormat);

export default dayjs;
